import * as React from 'react';
import SaleHeader from "~/apps/pos/mobile/components/sales/SaleHeader";
import BodyWrapper from "~/common/elements/mobile/BodyWrapper";
import PageMobileWrapper from "~/common/elements/mobile/PageMobileWrapper";
import Button from "~/common/elements/mobile/Button";
import {buttonSize, buttonStyle} from "~/common/elements/mobile/consts";
import FooterWrapper from "~/common/elements/mobile/FooterWrapper";
import { getSaleNumber } from "~/apps/pos/helpers";

type Props = {
  sale: any;
  onDelete: Function;
  onClose: Function;
  features: string[];
}

const SaleDelete = (props: Props) => {
  const { sale, onDelete, onClose, features } = props;

  return (
    <PageMobileWrapper className="m__cont--fh">
      <SaleHeader
        onClose={onClose}
        title="Delete Payment"
      />
      <BodyWrapper>
        <div className="m__body__titl">Are you sure you want to delete sale #{getSaleNumber(sale, features)}?</div>
      </BodyWrapper>
      <FooterWrapper>
        <div className="m__foot__btns">
          <div className="m__foot__btns__dbl">
            <Button
              title="Yes"
              buttonStyle={buttonStyle.PRIM}
              buttonSize={buttonSize.LG}
              onClick={onDelete}
            />
            <Button
              title="No"
              buttonStyle={buttonStyle.WARN}
              buttonSize={buttonSize.LG}
              onClick={onClose}
            />
          </div>
        </div>
      </FooterWrapper>
    </PageMobileWrapper>
  )
}

export default SaleDelete
